import { useContext } from 'react';
import { ModalContext, ModalComponent } from '../context/modalContext';
import { AnyObject } from '@bnetex/shared/types';

export const useModalContext = () => useContext(ModalContext);

export const useModal = <P extends AnyObject>(modal: ModalComponent<P>) =>
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useContext(ModalContext)!.useModal(modal);
